import gtm from '@/utils/gtm';
import { IPageStatus } from '@elem/compPage/delta-3-max-series/config/IPageStatus';
import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import { useProductDispatch, useProductStore } from '../../ProductStationProvider';
import styles from './index.module.scss';
import { LangText } from './LangText';
export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { locale = 'us', pathname } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);
    const { pageStatus } = useProductStore();
    const dispatch = useProductDispatch();

    const dataA: EcoNavProductProps = {
        productItems: [
            {
                value: 'name1',
                label: TextA.product_name,
                href: thePageUrl,
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : thePageUrl,
            },
            {
                value: 'Specs',
                label: TextA.tab_specs,
                // href: `${thePageUrl}/specs`,
            },
            {
                value: 'Support',
                label: TextA.tab_support,
                // href: `${thePageUrl}/support`,
            },
            {
                value: 'Bundles',
                label: '',
            },

            // {
            //     value: 'Media',
            //     label: TextA.tab_media,
            //     href: `${thePageUrl}/media`,
            // },
        ],
        buyItems: [
            {
                value: 'Bundles',
                label: pageStatus === IPageStatus.statusB ? TextA.btn_buy2 : TextA.btn_buy,
                // href: isInProductPage ? undefined : `${thePageUrl}?tab=Bundles`,
            },
        ],
        dataLayerBuy: {
            event: 'uaEvent',
            event_name: 'product_navigation',
            navigation_name: pageStatus === IPageStatus.statusB ? TextA.btn_buy2 : TextA.btn_buy,
            product_name: 'delta-3-max-series',
        },
    };
    const tabChange = (item: any, index: number) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.value,
        });
        if (tabCallback) {
            tabCallback(item.value);
        }
    };
    const handleBuyChange = (item: any, index: number) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.value,
        });
        if (tabCallback) {
            tabCallback('Bundles');
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_navigation',
            navigation_name: pageStatus === IPageStatus.statusB ? TextA.btn_buy2 : TextA.btn_buy,
            product_name: 'delta-3-max-series',
            __btn_id1: `eco-nav-product .__buy-1`,
            __btn_id2: 'Bundles',
            __btn_type: 'common',
        });
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} onBuyChange={handleBuyChange} />
        </div>
    );
}
